"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DISCONNECTED_PROVIDER = exports.EspType = exports.EspMisconfiguredReason = exports.EspConnectionStatus = exports.MAILCHIMP_SYNC_STATUS = exports.ESP_TYPE = exports.ESP_SYNC = exports.ESP_MISCONFIGURED_REASON = exports.ESP_LAST_ERROR = exports.ESP_CONNECTION_STATUS = exports.ESP_API_KEY = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var _DISCONNECTED_PROVIDE;

var ESP_API_KEY = 'espApiKey';
exports.ESP_API_KEY = ESP_API_KEY;
var ESP_CONNECTION_STATUS = 'espConnectionStatus';
exports.ESP_CONNECTION_STATUS = ESP_CONNECTION_STATUS;
var ESP_LAST_ERROR = 'espLastError';
exports.ESP_LAST_ERROR = ESP_LAST_ERROR;
var ESP_MISCONFIGURED_REASON = 'espMisconfiguredReason';
exports.ESP_MISCONFIGURED_REASON = ESP_MISCONFIGURED_REASON;
var ESP_SYNC = 'EspSync';
exports.ESP_SYNC = ESP_SYNC;
var ESP_TYPE = 'espType';
exports.ESP_TYPE = ESP_TYPE;
var MAILCHIMP_SYNC_STATUS = 'espSyncStatus';
exports.MAILCHIMP_SYNC_STATUS = MAILCHIMP_SYNC_STATUS;
var EspConnectionStatus = (0, _keyMirror.default)({
  BROKEN: null,
  CONNECTED: null,
  NOT_CONNECTED: null,
  UNKNOWN: null
});
exports.EspConnectionStatus = EspConnectionStatus;
var EspMisconfiguredReason = (0, _keyMirror.default)({
  INVALID_CREDENTIALS: null,
  NO_CREDENTIALS: null,
  OTHER: null
});
exports.EspMisconfiguredReason = EspMisconfiguredReason;
var EspType = (0, _keyMirror.default)({
  AWEBER: null,
  CAMPAIGN_MONITOR: null,
  CONSTANT_CONTACT: null,
  GET_RESPONSE: null,
  MAILCHIMP: null,
  MAILCHIMP_OAUTH: null,
  NONE: null
});
exports.EspType = EspType;
var DISCONNECTED_PROVIDER = (_DISCONNECTED_PROVIDE = {}, (0, _defineProperty2.default)(_DISCONNECTED_PROVIDE, ESP_API_KEY, ''), (0, _defineProperty2.default)(_DISCONNECTED_PROVIDE, ESP_CONNECTION_STATUS, EspConnectionStatus.NOT_CONNECTED), (0, _defineProperty2.default)(_DISCONNECTED_PROVIDE, ESP_TYPE, EspType.NONE), _DISCONNECTED_PROVIDE);
exports.DISCONNECTED_PROVIDER = DISCONNECTED_PROVIDER;